<template>
    <div class="AuthForm AModal__body">
        <div class="AModal__title">{{params.messages.logInBtn}}</div>
        <form :action="params.formLogIn.action" name="loginForm" :method="params.formLogIn.method" @submit.prevent="onSubmit">
            <AuthTabs v-model="fieldValues.type" :tabs="registerTabsData"/>
          <template v-for="field in fieldValues.fields">

            <AInput :label="field.title"
                    :placeholder="field.placeholder"
                    :type="field.type"
                    :name="field.name"
                    :req="field.required"
                    :error="field.error"
                    :validator="validator"
                    v-model="field.value"
                    static-label
                    v-if="field.type!='hidden'"
            >
                <template #error>
                    
                </template>
            </AInput>
            <input type="hidden" v-else :name="field.name" v-model="field.value" :req="field.required">
          </template>

            <div class="row mb-4 pt-4">
                <div class="col d-12 flex between v-center">
                    <ACheckbox :label="params.messages.memberMe" v-model="fieldValues.remember"/>
                    <ABtn class="flat" @click.prevent.native="forgot" :label="params.messages.forgetPass" type="button"/>
                </div>
            </div>
            <ABtn class="primary w-100 mb-4" type="submit" :label="params.messages.regBtn"/>
        </form>
        <div class="row">
            <div class="col d-12 text-center AModal__footer">
              {{ params.messages.regText }} <a @click.prevent="setRegistrationForm">{{ params.messages.title }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import {computed, ref} from 'vue';
import {useStore} from 'vuex';
import AuthTabs from "./AuthTabs";
import {AInput, ACheckbox, ABtn} from '~/components/ui'
import useTabsValue from "../../../composables/useTabsValue";
import {TAB_CODES} from "../../../composables/useTabsValue";
import {AUTH_STATES} from "../../../store/modules/auth";
import {required, isEmail, isPhone, isIdentical} from '~/libs/Validators'
import {useAProgressBar} from "../../ui";
import {send} from "../../../services/api";

export default {
    name: "LoginForm",
    props: {
        params: {
            type: Object
        }
    },
    components: {
        AuthTabs,
        AInput,
        ACheckbox,
        ABtn
    },
    setup(props, ctx) {
        const $store = useStore();
        const {registerTabsData} = useTabsValue(props, ctx)
        const progress = useAProgressBar();
        const fieldValues = ref({
          type: TAB_CODES.volunteer,
          fields:props.params.formLogIn.fields
        })

        const onSubmit = async () => {
          let canSend = true;
          const formData = new FormData();
          for (let index in fieldValues.value.fields) {
            if(fieldValues.value.fields[index]) {
              if (!validator(fieldValues.value.fields[index].value, fieldValues.value.fields[index].type, fieldValues.value.fields[index].required)) {
                canSend = false;
              } else {
                formData.append(fieldValues.value.fields[index].name, fieldValues.value.fields[index].value);
              }
            }
          }
          if (canSend) {
            progress.show();
            await send(props.params.formLogIn.action, {method: props.params.formLogIn.method}, formData).then((response) => {
              if(response.AuthPageContainer.authorized) {
                location.href = response.AuthPageContainer.personalLink;
              } else if(response.AuthPageContainer.errors) {
                for(let index in response.AuthPageContainer.errors) {
                  showNotification("danger",'',response.AuthPageContainer.errors[index]);
                }
              }
              progress.hide();
            });
          }
        }

        const setRegistrationForm = () => {
            $store.commit('auth/setAuthState', AUTH_STATES.registration)
            console.log('register..')
        }

        const forgot = () => {
            $store.commit('auth/setAuthState', AUTH_STATES.restore)
            console.log('forgot..')
        }

        // @todo to composable
        const validator = (val, type, req) => {
            if (type === undefined) {
                type = event.target.attributes.type?.value;
            }
            if (req === undefined&&event.target.attributes?.req) {
                req = event.target.attributes.req?.value;
            }
            let res = true;
            switch (type) {
                case "phone":
                    res = isPhone(val);
                    break;
                case "email":
                    res = isEmail(val);
                    break;
            }
            if (res && req) {
                res = required(val);
            }
            return res;
        };
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.get('type')==='forget') {
            forgot();
        }

        return {
            registerTabsData,
            fieldValues,
            onSubmit,
            setRegistrationForm,
            forgot,
            validator,
        }
    }
}
</script>

<style scoped>

</style>